import { numberFormat } from './intl-cache';

export const formatNumber = (
  value: number,
  locale: string,
  options?: Intl.NumberFormatOptions,
): string => numberFormat(locale, options).format(value);

export const formatCurrency = (value: number, locale: string, currency = 'BRL'): string =>
  formatNumber(value, locale, { style: 'currency', currency });
